"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExperimentIconDiv = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var ExperimentIconDiv = exports.ExperimentIconDiv = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n  font-size: 16px;\n  height: 20px;\n  width: 20px;\n  text-align: center;\n  vertical-align: middle;\n  margin-left: 4px;\n  display: inline-block;\n"])), function (props) {
  return props.background;
}, function (props) {
  return props.color;
});